<template>
    <div class="layout-default flex h-screen w-full">
        <div class="app-aside">
            <layout-sidebar />
        </div>

        <div class="flex-1 flex flex-col min-w-0">
            <div class="app-header" ref="appHeaderRef">
                <layout-header />
            </div>
            <div class="app-main flex-1 min-h-0">
                <layout-main />
                <div ref="appFooterHeightRef">
                    <layout-footer />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import LayoutMain from './components/main.vue'
import LayoutSidebar from './components/sidebar/index.vue'
import LayoutHeader from './components/header/index.vue'
import LayoutFooter from '@/layout/default/components/footer/index.vue'
import { useElementSize, useWindowSize } from '@vueuse/core'

const appHeaderRef = ref()
const appFooterHeightRef = ref()

const { height: appHeaderHeight } = useElementSize(appHeaderRef)
const { height: appFooterHeight } = useElementSize(appFooterHeightRef)
const { height: winHeight } = useWindowSize()

// 其他组件总高度
const appOhterHeight = computed(
    () => appHeaderHeight.value + appFooterHeight.value
)

// 去除其他组件可用高度
const usableHeight = computed(() => {
    return winHeight.value - appOhterHeight.value
})
const ySpace = 16
const cardSpace = 10
const pageSpace = 12

const appComponentsHeight = {
    // header组件高度
    appHeaderHeight,
    // footer组件高度
    appFooterHeight,
    // 其他组件高度
    appOhterHeight,
    // 窗口高度
    winHeight,
    // 去除其他组件可用高度
    usableHeight,
    // 间距
    ySpace,
    // card间距
    cardSpace,
    pageSpace
}
provide('appComponentsHeight', appComponentsHeight)
</script>
